export default __webpack_public_path__ + "static/char-v-30-2bebe602b49f450c1b4d203e684cc2bd.png";